import { useEffect, useState } from 'react';
import { examLibraryApi } from '../services/api';
import { useOrg } from '../context/OrgContext';

// Fetches exam metadata (title, description) for page headers. Failures are
// swallowed on purpose — pages fall back to a generic title.
export default function useExamDetail(examId) {
  const org = useOrg();
  const orgId = org?.id;
  const [exam, setExam] = useState(null);

  useEffect(() => {
    if (!examId || !orgId) return undefined;
    let cancelled = false;
    setExam(null);
    examLibraryApi.getDetail(orgId, examId)
      .then((res) => { if (!cancelled) setExam(res.data?.exam || res.data || null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [orgId, examId]);

  return exam;
}
